import SumoLogger from 'sumo-logger';
import { ENVIRONMENTS } from 'shared/utils/environment/types';

export enum FetchMethod {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  DELETE = 'DELETE',
  GET_ASSET = 'GET_ASSET',
}

export enum LogLevel {
  INFO = 'info',
  ERROR = 'error',
}

type LogFn = (body: LogData) => void;

export interface LogData {
  user_id?: string;
  user_email: string;
  msg: string;
  level: LogLevel;
  additionalInfo?: AdditionalAppLogInfo | AdditionalSwLogInfo | null;
  full_error_object?: any;
  logId?: string;
  grouping?: LogEventGrouping;
}

/**
 * How error trackers group and filter the event. Logs that differ only by an
 * entity name would otherwise each become a separate issue.
 */
export interface LogEventGrouping {
  /** Events with the same fingerprint are grouped into one issue. */
  fingerprint?: string[];
  tags?: Record<string, string>;
}

export type SharedLogsParams = LogData & {
  loggers: (SumoLogger | { log: LogFn })[];
};

export type LogDestinationUrls = Record<ENVIRONMENTS, string>;

export interface AdditionalSwLogInfo {
  query?: object;
  response?: object;
  headersData?: object;
  userData?: object;
  syncKey?: string;
  setup?: object;
  service?: object;
  entityName?: string;
  projectId?: string;
  /** HTTP status of the failed request, when there was a response. */
  httpStatus?: number;
  /** `null` when the API is not available. */
  online?: boolean | null;
  /** Version of the worker's script, to tell an outdated worker from the page. */
  client_version?: string;
  /** The stored data a log is about (data scopes, service tables). */
  data?: {
    /** Who the data belongs to: `project` or `user`. */
    owner?: string;
    /** The operation whose write was skipped, or the operation on the tables that failed. */
    operation?: string;
    tables?: string[];
    storedProjectId?: string;
    configuredProjectId?: string;
    /** The item a read by id did not find. */
    itemId?: string;
  };
  /** The state of every `<entity>Service` table, one line per entity (`describeEntitySync`). */
  serviceTables?: Record<string, string> | { snapshotFailed: string };
}

export interface AdditionalAppLogInfo {
  client_version: string | null;
  user_email: string;
  user_id: string;
}

export interface FetchErrorDetails {
  requestError: any;
  requestData: any;
  requestConfig: any;
  url: string;
  method: FetchMethod;
  response: any;
}

export type SwLogger = (
  message: string,
  logLevel: LogLevel,
  errorObject: unknown,
  additionalInfo: AdditionalSwLogInfo | null,
  grouping?: LogEventGrouping
) => void;

export interface DeviceInfo {
  device: {
    isMobile: boolean;
    userAgent: string;
    logicalProcessors: number;
  };
}
